import { Icon, type IconName } from "./Icons";

// A console switch: machined dark-metal face, line icon, uppercase label, LED indicator strip.
export default function Btn({
  label, icon, onClick, active, danger, busy, wide, round,
}: {
  label: string; icon: IconName; onClick: () => void;
  active?: boolean; danger?: boolean; busy?: boolean; wide?: boolean; round?: boolean;
}) {
  return (
    <button
      className={`ctl ${active ? "active" : ""} ${danger ? "danger" : ""} ${wide ? "wide" : ""} ${round ? "round" : ""} ${busy ? "busy" : ""}`}
      onClick={onClick}
      disabled={busy}
    >
      <span className="ctl-led" />
      <span className="ctl-icon"><Icon name={icon} /></span>
      <span className="ctl-label">{label}</span>
    </button>
  );
}
